import Vue from 'vue'

// temporary storage for passing data from closed order to order confirmation component
var order = {
  data: {}
}

export default order